module.exports = __webpack_public_path__ + "static/img/exportbanner.b10f00d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/exportbanner.jpg
// module id = sJyt
// module chunks = 6